/**
 * @packageDocumentation
 * @module api.functional.invitations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { PaginationQuery } from "../../structures/PaginationQuery";
import type { ServiceResponse__object } from "../../structures/ServiceResponse__object";
import type { ServiceResponsenull } from "../../structures/ServiceResponsenull";

export * as all from "./all/index";
export * as pending from "./pending/index";
export * as preview from "./preview/index";
export * as resend from "./resend/index";

/**
 * @controller InvitationController.getCompanyInvitations
 * @path GET /invitations
 * @accessor api.functional.invitations.getCompanyInvitations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getCompanyInvitations(
  connection: IConnection,
  paginationQuery: getCompanyInvitations.Query,
): Promise<getCompanyInvitations.Output> {
  return PlainFetcher.fetch(connection, {
    ...getCompanyInvitations.METADATA,
    template: getCompanyInvitations.METADATA.path,
    path: getCompanyInvitations.path(paginationQuery),
  });
}
export namespace getCompanyInvitations {
  export type Query = PaginationQuery;
  export type Output = ServiceResponse__object;

  export const METADATA = {
    method: "GET",
    path: "/invitations",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (paginationQuery: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(paginationQuery as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/invitations";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller InvitationController.respondToInvitation
 * @path PATCH /invitations/:token
 * @accessor api.functional.invitations.respondToInvitation
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function respondToInvitation(
  connection: IConnection,
  token: string,
  body: respondToInvitation.Body,
): Promise<respondToInvitation.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...respondToInvitation.METADATA,
      template: respondToInvitation.METADATA.path,
      path: respondToInvitation.path(token),
    },
    body,
  );
}
export namespace respondToInvitation {
  export type Body = {
    action: "accept" | "decline";
  };
  export type Output = {
    status: "PENDING" | "ACCEPTED" | "DECLINED" | "EXPIRED";
  };

  export const METADATA = {
    method: "PATCH",
    path: "/invitations/:token",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (token: string) =>
    `/invitations/${encodeURIComponent(token?.toString() ?? "null")}`;
}

/**
 * @controller InvitationController.deleteInvitation
 * @path DELETE /invitations/:id
 * @accessor api.functional.invitations.deleteInvitation
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function deleteInvitation(
  connection: IConnection,
  id: string,
): Promise<deleteInvitation.Output> {
  return PlainFetcher.fetch(connection, {
    ...deleteInvitation.METADATA,
    template: deleteInvitation.METADATA.path,
    path: deleteInvitation.path(id),
  });
}
export namespace deleteInvitation {
  export type Output = ServiceResponse__object | ServiceResponsenull;

  export const METADATA = {
    method: "DELETE",
    path: "/invitations/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/invitations/${encodeURIComponent(id?.toString() ?? "null")}`;
}
